// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__362y-","header":"PatientBlock_header__1v-4k","label":"PatientBlock_label__3ZzGX","option":"PatientBlock_option__cB0jW"};